var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9033 40.6488V28.4656C26.2589 28.4968 26.5983 28.513 26.9539 28.513C28.6484 28.513 30.2443 28.0663 31.5994 27.2715V40.6476C31.5994 41.7893 31.3274 42.634 30.8033 43.198C30.2793 43.7595 29.5817 44.0403 28.7345 44.0403C27.9035 44.0403 27.2422 43.7595 26.6994 43.1818C26.1753 42.6191 25.9033 41.7731 25.9033 40.6488Z",
    fill: "#003A9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9361 11.4475C29.4623 10.2047 33.4801 10.2708 36.4972 12.82C37.0587 13.3328 37.7013 13.9792 37.9559 14.7403C38.2616 15.6999 36.889 14.6392 36.7006 14.5095C35.7174 13.8794 34.7341 13.3503 33.6336 12.9847C27.7004 11.1979 22.0867 14.4259 18.5967 19.4419C17.1393 21.6605 16.1885 23.9925 15.4087 26.5592C15.325 26.8424 15.2564 27.2068 15.1017 27.4526C14.9495 27.7371 15.0343 26.694 15.0343 26.659C15.1516 25.6009 15.3737 24.574 15.6457 23.5471C17.2578 18.0843 20.8165 13.5325 25.9361 11.4475Z",
    fill: "#003A9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5316 25.0045C28.4129 26.0639 25.8176 25.2379 24.7495 23.1678C23.6639 21.0978 24.5136 18.566 26.6311 17.5229C28.7511 16.4635 31.3464 17.2908 32.4133 19.3609C33.4988 21.4297 32.6516 23.9626 30.5316 25.0045Z",
    fill: "#003A9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeed);
export default __webpack_public_path__ + "static/media/indeed.829e36ac14ed89de5bcb2a845c4419f8.svg";
export { ForwardRef as ReactComponent };